<template>
  <div class="activityBasicInformation">
    <!--费用归属-->
    <activistyCostAttribution ref="activistyCostAttribution" :echo-data="echoData" @jumpTabsHandle="handleTabsClick" @refresh="handleRefresh" />
    <!-- 合规附件信息 -->
    <detailsCompliance v-if="isCompliance" :edit-echo-data="echoData" @refresh="handleRefresh" />
    <!--锐捷基本信息-->
    <rjBasicInformation v-if="basicInformationFlage === 0" :edit-echo-data="echoData" />
    <rjQuickBasicInformation v-if="basicInformationFlage === 1" :edit-echo-data="echoData" no-border-mode />
    <!--渠道基本信息-->
    <qdBasicInformation v-if="basicInformationFlage === 2" :edit-echo-data="echoData" />
    <qdQuickBasicInformation v-if="basicInformationFlage === 3" :edit-echo-data="echoData" no-border-mode />
    <div class="customerFileWrap">
      <div class="common_group" v-if="customerTableData.length > 0">
        <div class="title">
          <img src="@/assets/images/userIcon.png">
          <span>{{ $t('newApp.Customers.ctbi') }}</span>
        </div>
        <commonTable ref="statisticsTable" style="margin-bottom:20px" v-show="!$store.state.useSimplifiedForm" />
        <commonTable ref="activityDetailsCustomerTable" />
      </div>
      <div class="common_group" v-if="fileTableData.length > 0">
        <div class="title">
          <img src="@/assets/images/fileIcon.png">
          <span>{{ $t('file.aa') }}</span>
        </div>
        <commonTable ref="activityDetailsFileTable" />
      </div>
    </div>
    <activityTargetValue v-if="!$store.state.useSimplifiedForm && basicInformationFlage == 0" :edit-echo-data="echoData" />
    <agreeDialog :approved="approved" :dialog-title="agreeDialogTitle" :echo-data="echoData"
                 :agree-dialog-visible="agreeDialogVisible" @agreeSubHandle="agreeSubHandle"
                 @dialogCloseHandle="agreeDialogCloseHandle"
    />
  </div>
</template>

<script>
// import rjBasicInformation from '@/views/newApplicationForm/component/newApplicationForm/rjBasicInformation';
import rjBasicInformation from '@/views/activitieList/component/activityDetails/basicInformation/rjBasicInformation';
import rjQuickBasicInformation from '@/views/activitieList/component/activityDetails/basicInformation/rjquickBasicInformation';
// import qdBasicInformation from '@/views/newApplicationForm/component/newApplicationForm/qdBasicInformation';
import qdBasicInformation from '@/views/activitieList/component/activityDetails/basicInformation/qdBasicInformation';
import qdQuickBasicInformation from '@/views/newApplicationForm/component/quickApplicationForm/qdQuickBasicInformation';
import activistyCostAttribution from './activistyCostAttribution';
import agreeDialog from '../../component/activityDetails/activistyCostAttribution/agreeDialog';
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { activityQueryDetails } from '@/views/activitieList/service';
import activityTargetValue from './activityTargetValue';
import detailsCompliance from '../../component/compliance/detailsCompliance.vue';
export default {
  data () {
    return {
      customerTableData: [],
      fileTableData: [],
      editRequestFlage: false,
      basicInformationFlage: 0, // 锐捷-0  锐捷快速-1  渠道-2  渠道快捷-3
      agreeDialogTitle: this.$t('btn.Agree'),
      agreeDialogVisible: false,
      approved: '',
      fileIconfont: {
        pdf: require('@/assets/images/iconfont-pdf.png'),
        doc: require('@/assets/images/iconfont-doc.png'),
        img: require('@/assets/images/iconfont-img.png'),
        ppt: require('@/assets/images/iconfont-ppt.png'),
        universal: require('@/assets/images/iconfont-universal.png'),
        xls: require('@/assets/images/iconfont-xls.png')
      }
    };
  },
  props: {
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTable,
    rjBasicInformation,
    rjQuickBasicInformation,
    qdBasicInformation,
    qdQuickBasicInformation,
    activistyCostAttribution,
    agreeDialog,
    activityTargetValue,
    detailsCompliance
  },
  computed: {
    isCompliance () {
      return this.echoData.marketActivity && this.echoData.marketActivity.isCompliance > 0;
    }
  },
  methods: {
    handleRefresh () {
      this.$emit('refresh');
    },
    handleTabsClick () {
      this.$emit('jumpTabsHandle', { name: 'travellingTrader' });
    },
    agreeDialogCloseHandle () {
      this.agreeDialogVisible = false;
    },
    agreeRejectBtn (val) {
      let selected = [];
      if (this.$refs.activistyCostAttribution) {
        selected = this.$refs.activistyCostAttribution.getCheckedItem();
      }
      if (selected.length > 0) {
        activityQueryDetails.getProcessHistory(selected[0].id).then(res => {
          if (res.status === '200') {
            let { mactFlowLogList } = res.data;
            this.approved = mactFlowLogList[mactFlowLogList.length - 1].assigneeName;
            this.agreeDialogTitle = val ? this.$t('btn.Agree') : this.$t('btn.Rejected');
            this.agreeRejectFlage = val;
            this.agreeDialogVisible = true;
          }
        });
      } else {
        this.$message.warning(this.$t('approvalCenter.PsaeiuFA'));
      }
    },
    agreeSubHandle (data) {
      let params = {
        reason: data.reason === '同意' ? '' : data.reason,
        directors: data.directors,
        taskIds: this.$refs.activistyCostAttribution.getCheckedItem().map(item => {
          return item.taskId;
        })
      };

      let requestUrl = activityQueryDetails.activistyCostApproval;
      if (!this.agreeRejectFlage) {
        requestUrl = activityQueryDetails.activistyCostReject;
      }

      this.$store.commit('setSubPageLoading', true);
      requestUrl(params).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          this.agreeDialogVisible = false;
          if (this.agreeRejectFlage) {
            this.$message.success(this.$t('general.AppSucc'));
          } else {
            this.$message.success(this.$t('general.Rejected'));
          }
          // 重新获取审批数量
          this.$store.dispatch('getPendingApprovalNum');
          this.$router.push({
            path: this.$route.query.metaActive ? this.$route.query.metaActive : '/activityQuery'
          });
        }
      });
    },
    fileDownloadBtn (row) {
      activityQueryDetails.getDownloadUrl(row.fileId).then(res => {
        if (res.status === '200') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = res.data;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    loadFileTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('file.Na'))
          ._data('fileName')
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let format = row.fileName.split('.')[1];
              let imgUrl = '';
              switch (format) {
                case 'jpg':
                case 'png':
                case 'gif':
                  imgUrl = this.fileIconfont.img;
                  break;
                case 'pdf':
                  imgUrl = this.fileIconfont.pdf;
                  break;
                case 'doc':
                case 'docx':
                  imgUrl = this.fileIconfont.doc;
                  break;
                case 'ppt':
                case 'pps':
                case 'pptx':
                  imgUrl = this.fileIconfont.ppt;
                  break;
                case 'xls':
                case 'xlsx':
                  imgUrl = this.fileIconfont.xls;
                  break;
                default:
                  imgUrl = this.fileIconfont.universal;
              }
              return (
                <div class="table_file">
                  <img src={imgUrl} />
                  <span>{row.fileName}</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('')
          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="primary" onClick={() => { this.fileDownloadBtn(row); }}>
                    <i class="iconfont icon-shangchuan-icon" />
                    {this.$t('general.Download')}
                  </el-button>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('file.UploadTime'))
          ._data('createTime')
          ._width('300')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityDetailsFileTable.setColumn(column, {
          page: false
        });
        this.$refs.activityDetailsFileTable.loadStaticTable(this.fileTableData);
      });
    },
    loadStatisticsTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.ca'))
          ._data('ca')
          ._width('15%')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noocc'))
          ._data('noocc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noucc'))
          ._data('noucc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolcc'))
          ._data('nolcc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noncc'))
          ._data('noncc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nocfuc'))
          ._data('nocfuc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolccx'))
          ._data('nolccx')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nonlcc'))
          ._data('nonlcc')
      );

      let column = tableRow._cols();
      this.$refs.statisticsTable.setColumn(column, {
        page: false
      });
    },
    loadCustomerTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.CustomerName'))
          ._data('clientName')
          ._width('12%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ci'))
          ._width('15%')
          ._data('isChannel')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.catt'))
          ._width('10%')
          ._data('accountMarked')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.accountMarked || '--'}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bo'))
          ._data('businessChance')
          ._width('15%')
      );
       tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.newBusOpp'))
          ._width('200px')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <span>
                  {
                    row.newBusOpp === 1 ? this.$t('general.yes') : (row.newBusOpp === 0 ? this.$t('general.no') : '--')
                  }
                </span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.pdty'))
          ._data('output')
          ._width('18%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cc'))
          ._data('columnName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bc'))
          ._data('mustFollowCustomer')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccd'))
          ._data('isOldAccount')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccon'))
          ._data('name')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.ContactNumber'))
          ._data('phone')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccat'))
          ._data('entityType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cst'))
          ._data('channelContractType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.noc'))
          ._data('circleName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.wtb'))
          ._data('coconstructionOrNot')
          ._width('10%')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityDetailsCustomerTable.setColumn(column, {
          page: true
        });
        this.$refs.activityDetailsCustomerTable.loadStaticTable(this.customerTableData, this.customerTableData.length);

        const tableList = this.customerTableData.filter((item, index, arr) => {
          return arr.findIndex(t => t.clientName === item.clientName) === index;
        });
        this.loadStatisticsTable();
        let statistics = {
          ca: {},
          noocc: 0,
          noucc: 0,
          nolcc: 0,
          noncc: 0,
          nocfuc: 0,
          nolccx: 0,
          nonlcc: 0,
          tbps: 0
        };

        tableList.forEach(item => {
          // 统计数据，拟邀请客户统计
          // 统计start
          let k = item.accountMarked ? (item.accountMarked === '--' ? '空' : item.accountMarked) : '空';
          if (!statistics.ca[k]) {
            statistics.ca[k] = 0;
          }
          statistics.ca[k]++;
          if (item.isOldAccount) {
            if (item.isOldAccount === '老客户') {
              statistics.noocc++;
            }
          }
          if (item.columnName) {
            if (item.columnName === '营销系统客户') {
              statistics.noucc++;
            }
            if (item.columnName === '列名客户') {
              statistics.nolcc++;
            }
            if (item.columnName === '非列名客户') {
              statistics.noncc++;
            }
            if (item.columnName === '营销系统渠道') {
              statistics.nocfuc++;
            }
            if (item.columnName === '列名渠道') {
              statistics.nolccx++;
            }
            if (item.columnName === '非列名渠道') {
              statistics.nonlcc++;
            }
          } else {
            statistics.noncc++;
          }
          // 统计end
        });
        // for (let i of this.statisticsTable) {
        //   this.$refs.statisticsTable.removeRow(i)
        // }
        let caContent = [];
        for (let k in statistics.ca) {
          caContent.push(`${k}${this.$t('newApp.ADList.no')}：${statistics.ca[k]}`);
        }

        const statisticsRow = {
          ...statistics,
          ca: caContent.length > 0 ? caContent.join('，') : '--'
        };
        // this.$refs.statisticsTable.insertRow(statisticsRow)
        this.$refs.statisticsTable.loadStaticTable([statisticsRow]);
      });
    }
  },
  created () {
    // 锐捷-0  锐捷快速-1  渠道-2  渠道快捷-3
    if (this.echoData.marketActivity.applyUserType === 'rj') {
      if (this.echoData.marketActivity.submitType === 'quick_submit') {
        this.basicInformationFlage = 1;
      } else {
        this.basicInformationFlage = 0;
      }
    } else {
      if (this.echoData.marketActivity.submitType === 'quick_submit') {
        this.basicInformationFlage = 3;
      } else {
        this.basicInformationFlage = 2;
      }
    }
  },
  mounted () {
    if (this.echoData.attachFileList.length > 0) {
      this.fileTableData = this.echoData.attachFileList;
      this.loadFileTable();
    }
    if (this.echoData.mactJoinCustomerList.length > 0) {
      this.customerTableData = this.echoData.mactJoinCustomerList;
      this.loadCustomerTable();
    }
  }
};
</script>

<style lang="scss" scoped>
.activityBasicInformation {
  >.customerFileWrap {
    .table_file {
      >img {
        vertical-align: middle;
      }

      >span {
        margin-left: 10px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  >.activityDetailsFile,
  .activityDetailsCustomer {
    box-sizing: border-box;
    padding-left: 20px;
    padding-bottom: 50px;
    margin-top: 16px;

    >.title {
      font-size: 16px;
      font-weight: bold;
      margin: 3px 0 20px;
    }
  }
}
</style>
